import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a3020a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "appoint-trust-coordinator-modal" }
const _hoisted_2 = { class: "heading-text" }
const _hoisted_3 = { class: "line1" }
const _hoisted_4 = { class: "body-main" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Search", -1))
const _hoisted_6 = { class: "search" }
const _hoisted_7 = { class: "search-bar" }
const _hoisted_8 = { class: "icon-hm" }
const _hoisted_9 = {
  key: 0,
  class: "fal fa-spinner fa-spin fa-lg"
}
const _hoisted_10 = {
  key: 1,
  class: "fal fa-search fa-lg"
}
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 0,
  class: "error mt-2"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle fa-lg" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "validation-msg mt-2" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle fa-lg" }),
  /*#__PURE__*/_createTextVNode(" Please be aware that you are limited to searching only for exact match ")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "label" }, "LawID", -1))
const _hoisted_17 = {
  key: 0,
  class: "validation-msg"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle fa-lg mr-2" }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_20 = { class: "col-6" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "label" }, "Last name", -1))
const _hoisted_22 = {
  key: 0,
  class: "validation-msg"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle fa-lg mr-2" }, null, -1))
const _hoisted_24 = { class: "col-6" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "label" }, "First name", -1))
const _hoisted_26 = {
  key: 0,
  class: "validation-msg"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle fa-lg mr-2" }, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "label" }, "LawID email", -1))
const _hoisted_30 = {
  key: 0,
  class: "validation-msg"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle fa-lg mr-2" }, null, -1))
const _hoisted_32 = { class: "controls" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = ["disabled"]

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ModalBox = _resolveComponent("ModalBox")
  const _component_ConfirmDialogue = _resolveComponent("ConfirmDialogue")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_ModalBox, {
      onClose: _cache[8] || (_cache[8] = $event => (_ctx.closeModal()))
    }, {
      "header-text": _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.line1Text), 1)
        ])
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: "Search for LawID or email",
                maxLength: "75",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.searchText) = $event))
              }, null, 512), [
                [_vModelText, _ctx.searchText]
              ]),
              _createElementVNode("span", _hoisted_8, [
                (_ctx.isSearching)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_9))
                  : (_openBlock(), _createElementBlock("i", _hoisted_10))
              ])
            ]),
            _createElementVNode("button", {
              class: "btn btn-secondary sml ml-2",
              disabled: _ctx.searchText.length === 0 || _ctx.isSearching,
              onClick: _cache[1] || (_cache[1] = $event => (_ctx.searchLawEmailID()))
            }, "Search", 8, _hoisted_11)
          ]),
          (_ctx.invalidLawIdEmail)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _hoisted_13,
                _createTextVNode(" Invalid LawID or email ")
              ]))
            : _createCommentVNode("", true),
          _hoisted_14,
          _hoisted_15,
          _hoisted_16,
          _createElementVNode("div", {
            class: _normalizeClass(["input-box", this.lawId === '' && _ctx.submitPressed ? 'error': ''])
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              maxLength: "75",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.lawId) = $event)),
              disabled: ""
            }, null, 512), [
              [_vModelText, _ctx.lawId]
            ]),
            (this.lawId === '' && _ctx.submitPressed)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _hoisted_18,
                  _createTextVNode("Required field. ")
                ]))
              : _createCommentVNode("", true)
          ], 2),
          _hoisted_19,
          _createElementVNode("div", {
            class: _normalizeClass(["names", this.lastName === '' && _ctx.submitPressed ? 'error': '']),
            style: {"display":"flex","justify-content":"space-between"}
          }, [
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("div", {
                class: _normalizeClass(["input-box", this.lastName === '' && _ctx.submitPressed ? 'error': ''])
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  maxLength: "75",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.lastName) = $event)),
                  disabled: ""
                }, null, 512), [
                  [_vModelText, _ctx.lastName]
                ])
              ], 2),
              (this.lastName === '' && _ctx.submitPressed)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _hoisted_23,
                    _createTextVNode("Required field. ")
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("div", {
                class: _normalizeClass(["input-box", this.firstName === '' && _ctx.submitPressed ? 'error': ''])
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  maxLength: "75",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.firstName) = $event)),
                  disabled: ""
                }, null, 512), [
                  [_vModelText, _ctx.firstName]
                ])
              ], 2),
              (this.firstName === '' && _ctx.submitPressed)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _hoisted_27,
                    _createTextVNode("Required field. ")
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2),
          _hoisted_28,
          _hoisted_29,
          _createElementVNode("div", {
            class: _normalizeClass(["input-box", this.email === '' && _ctx.submitPressed ? 'error': ''])
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              maxLength: "75",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.email) = $event)),
              disabled: ""
            }, null, 512), [
              [_vModelText, _ctx.email]
            ]),
            (this.email === '' && _ctx.submitPressed)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _hoisted_31,
                  _createTextVNode("Required field. ")
                ]))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_32, [
          (_ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_LoadingIndicator, {
                key: 0,
                class: "loading-indicator",
                showLoadingText: false
              }))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "btn btn-default ml-1",
            disabled: _ctx.isLoading,
            onClick: _cache[6] || (_cache[6] = _withModifiers($event => (_ctx.closeModal()), ["prevent","stop"]))
          }, "Cancel", 8, _hoisted_33),
          _createElementVNode("button", {
            class: "btn btn-primary ml-2",
            disabled: _ctx.isLoading,
            onClick: _cache[7] || (_cache[7] = $event => (_ctx.save()))
          }, "Save", 8, _hoisted_34)
        ])
      ]),
      footer: _withCtx(() => []),
      _: 1
    }),
    _createVNode(_component_ConfirmDialogue, {
      ref: "confirmDialogue",
      modalOpened: true
    }, null, 512)
  ]))
}